import {
  UserToken as UserTokenDomainModeType,
  IUser as IUserDomainModelType
} from '../models/user';
export type UserToken = UserTokenDomainModeType;

export type IUser = IUserDomainModelType;

export const author1: IUser = {
  id: 'fc7f23ef-e3dd-490d-840f-9b0fce6309e7',
  firstName: 'A.Matthew',
  lastName: 'Lewis',
  email: 'lewis.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const author1PreProd: IUser = {
  ...author1,
  id: '8fc6a9d1-212b-449a-9b86-5f94688d2456'
};

const editor1: IUser = {
  id: 'c7848724-9160-490f-9561-0df67041794a',
  firstName: 'A.Aiden',
  lastName: 'Cruz',
  email: 'aiden.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const editor1PreProd: IUser = {
  ...editor1,
  id: 'bba8d6a2-8917-4d9b-a335-506f291fe1ae'
};

const editor2: IUser = {
  id: '534d9e90-ba30-493d-9062-6f8a4a2e6dbf',
  firstName: 'C.Charlotte',
  lastName: 'Davis',
  email: 'charlotte.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};
const editor2PreProd: IUser = {
  ...editor2,
  id: '2c746449-038a-4125-a71a-6b1c1d33d1b2'
};

const editor3: IUser = {
  id: 'd15dcd08-748f-4f64-9045-889714e30e84',
  firstName: 'S.Simon',
  lastName: 'Clarke',
  email: 'simon.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};
const editor3PreProd: IUser = {
  ...editor3,
  id: 'ee65ea73-2535-4f49-aeb8-13b0a6038de8'
};

const reviewer1: IUser = {
  id: '3f5aec34-6a57-4ab9-b1e3-e188e59acd08',
  firstName: 'R.John',
  lastName: 'Doe',
  email: 'doe.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const reviewer1PreProd: IUser = {
  ...reviewer1,
  id: '7beb8fd4-7da0-4fc4-9d6b-9676b9ac5864'
};

const reviewer2: IUser = {
  id: '07bef5ac-7435-4a42-beb8-2609cf210f0a',
  firstName: 'R.Monalisa',
  lastName: 'Paine',
  email: 'paine.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const reviewer2PreProd: IUser = {
  ...reviewer2,
  id: 'b906f751-308f-4b3a-b0b8-e30a35194dea'
};

const orgAdmin1: IUser = {
  id: '8af267b7-dda8-432b-b7bc-2e182a48184f',
  firstName: 'O.Oscar',
  lastName: 'Odin',
  email: 'odin.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const orgAdmin1PreProd: IUser = {
  ...orgAdmin1,
  id: '2ad524dc-2127-4237-866b-86d508f37b4b'
};
const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: '52b4f8a3-2064-4e13-aaf2-224acb71d1fc'
};

const sysAdmin1: IUser = {
  id: '574c131d-3df7-48ca-bfed-9fc06ea56eb5',
  firstName: 'Sudo',
  lastName: 'User',
  email: 'sudo.mag.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '0000-0002-0384-6285',
  realm: 'mag',
  status: 'active'
};

const sysAdmin1PreProd: IUser = {
  ...sysAdmin1,
  id: 'a5b75234-177c-4ca8-9587-a09e65b0d91f'
};

const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: '4b9b160d-86d7-4035-ade6-28b7893fb344'
};

export const STAGING_USERS_MAP = {
  author1,
  editor1,
  editor2,
  editor3,
  reviewer1,
  reviewer2,
  orgAdmin1,
  sysAdmin1
} as const;

export const PREPROD_USERS_MAP = {
  author1: author1PreProd,
  editor1: editor1PreProd,
  editor2: editor2PreProd,
  editor3: editor3PreProd,
  reviewer1: reviewer1PreProd,
  reviewer2: reviewer2PreProd,
  orgAdmin1: orgAdmin1PreProd,
  sysAdmin1: sysAdmin1PreProd
} as const;

export const PROD_USERS_MAP = {
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod
} as const;
